import type { Store } from '@reduxjs/toolkit';
import type { TypedUseSelectorHook } from 'react-redux';
import { useDispatch, useSelector, useStore } from 'react-redux';
import type { AppDispatch, RootState } from 'src/redux/store';

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
// Typed `useStore` — returns the Provider's store so callers can read the LATEST
// committed state at call time (via `getState()`) instead of a render-stale selector value.
export const useAppStore: () => Store<RootState> = useStore.withTypes<Store<RootState>>();
